import { render, staticRenderFns } from "./ConfigColor.vue?vue&type=template&id=66cd506a"
import script from "./ConfigColor.vue?vue&type=script&lang=js"
export * from "./ConfigColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports